export default {"src":"/_next/static/media/openIcon.793f1661.svg","height":26,"width":24,"blurWidth":0,"blurHeight":0};